'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Remove;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Remove(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-remove ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M1 2.625V1.75c0-.208.073-.385.219-.531A.723.723 0 0 1 1.75 1h3.5l.281-.594A.702.702 0 0 1 5.812.11.792.792 0 0 1 6.22 0H9.78c.146 0 .281.036.406.11a.702.702 0 0 1 .282.296L10.75 1h3.5c.208 0 .385.073.531.219A.723.723 0 0 1 15 1.75v.875a.362.362 0 0 1-.11.266.362.362 0 0 1-.265.109H1.375a.362.362 0 0 1-.266-.11A.362.362 0 0 1 1 2.626zm13 1.75V14.5c0 .417-.146.77-.438 1.062A1.447 1.447 0 0 1 12.5 16h-9c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 2 14.5V4.375c0-.104.036-.193.11-.266A.362.362 0 0 1 2.374 4h11.25c.104 0 .193.036.266.11.073.072.109.16.109.265zM5.5 6.5a.487.487 0 0 0-.14-.36A.487.487 0 0 0 5 6a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v7c0 .146.047.266.14.36.094.093.214.14.36.14a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36v-7zm3 0a.487.487 0 0 0-.14-.36A.487.487 0 0 0 8 6a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v7c0 .146.047.266.14.36.094.093.214.14.36.14a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36v-7zm3 0a.487.487 0 0 0-.14-.36A.487.487 0 0 0 11 6a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v7c0 .146.047.266.14.36.094.093.214.14.36.14a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36v-7z' })
  );
}

Remove.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Remove/Remove.js
// module id = 317
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16